// extracted by mini-css-extract-plugin
export default {"cls1":"g5CiqdYwfBkOAwIQZfvw","cls2":"fRZ1Wbd7faW2ayi9GVdJ g5CiqdYwfBkOAwIQZfvw","isPhone":"SM_L7no6BZUnK0oqRQN1"};